module.exports = __webpack_public_path__ + "img/icon1.c84f0449.png";